<template>
  <div>
    <label class="mt-2"> {{ $t("policy.compliance-acceptance.description") }}</label>
    <textarea :disabled="disabled" v-model="form.description" type="text" class="form-control" :placeholder="$t('common.description')" rows="3"></textarea>
    <!-- <sweet-button @click="save()" type="submit" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button> -->
  </div>
</template>

<script>
export default {
  props: ["policy", "complianceStatus", "disabled", "preventSubmit"],
  computed: {},

  data() {
    return {
      oldValue: undefined,
      form: {
        description: undefined,
      },
    };
  },
  watch: {
    complianceStatus: {
      immediate: true,
      deep: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
    "form.description": {
      handler(v) {
        if (v !== this.oldValue) {
          this.debounce(() => this.save(), "none", 2000);
        }
      },
    },
  },

  methods: {
    async save() {
      try {
        if (this.disabled) {
          return;
        }
        if (this.preventSubmit) {
          this.$emit("saved", this.form.description);
          return;
        }

        await this.$store.dispatch("organizationPolicy/updateComplianceDescription", {
          id: this.policy._id,
          conditionDefinitionId: this.complianceStatus.definitionId,
          description: this.form.description,
        });
        this.$toast.success(this.$t("policy.compliance-description-saved"));

        this.$emit("onSubmit");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
